import React from 'react'
import styled from 'styled-components'

interface ImgProps {
    $width?: string
    $height?: string
    $borderradius?: string
}

const StyledImage = styled.img<ImgProps>`
    width: ${(p) => p.$width};
    height: ${(p) => p.$height};
    border-radius: ${(p) => p.$borderradius};
`

interface Props {
    src: string
    fill?: boolean
    width?: number
    height?: number
    borderradius?: number
    alt: string
    style?: React.CSSProperties
    onClick?: any
    borderfill?: boolean
}

const Image: React.FC<Props> = ({
    src,
    width,
    height,
    borderradius = 0,
    alt,
    style,
    onClick,
    fill = false,
    borderfill = false,
}) => {
    const finalWidth = fill ? '100%' : `${width}px`
    const finalHeight = fill ? '100%' : `${height}px`
    const finalborderradius = borderfill ? '100%' : `${borderradius}px`
    return (
        <StyledImage
            style={style}
            src={src}
            $width={finalWidth}
            $height={finalHeight}
            $borderradius={finalborderradius}
            alt={alt}
            onClick={onClick}
        />
    )
}

export default Image
